import api from "@/api/api";
import {iniciarRequisicao, logout} from "@/helpers";
import {STATUS_HTTP} from "@/api/statusHTTP";

const PREFIXO_URL = '/produtos/demanda-combinada';

export const cadastrarProdutoDemandasCombinadas = async (params) => {
  const {data, status} = await api.post(PREFIXO_URL, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.CREATED) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}

export const atualizarProdutoDemandasCombinadas = async (params) => {
  const {data, status} = await api.put(`${PREFIXO_URL}/${params.id}`, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}

export const apagarProdutoDemandasCombinadas = async (id) => {
  const {data, status} = await api.delete(`${PREFIXO_URL}/${id}`, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}

export const buscarComparacaoProdutos = async (params) => {
  const {data, status} = await api.get(`${PREFIXO_URL}/comparacao-produtos`, {params, headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.produtos
  }

  logout();
}
